export default __webpack_public_path__ + "static/media/paycard-farm-esquivar.9899aa60.png";